import { defineComponent, PropType } from "vue";
import { RoleChip } from "./RoleChip.js";
import {
    formatPermissionLabel,
    type PermissionChange,
} from "./rolePermissionsModel.js";

export default defineComponent({
    name: "PermissionChangeSummary",

    props: {
        changes: {
            type: Array as PropType<PermissionChange[]>,
            required: true,
        },
    },

    setup(props) {
        return () => (
            <div class="bulk-role-change-list">
                {props.changes.map(({ role, before, after, changedPermissions }) => (
                    <article class="bulk-role-change" key={role.id}>
                        <div class="bulk-role-change-role">
                            <RoleChip role={role} />
                            <span>{changedPermissions.length} changement{changedPermissions.length > 1 ? "s" : ""}</span>
                        </div>

                        <div class="bulk-role-change-permissions">
                            {changedPermissions.map((permission) => {
                                const added = (after & permission.bit) !== 0n && (before & permission.bit) === 0n;

                                return (
                                    <span key={permission.key} class={{ added, removed: !added }}>
                                        <i class="material-symbols-outlined">{added ? "add_circle" : "remove_circle"}</i>
                                        {formatPermissionLabel(permission)}
                                    </span>
                                );
                            })}
                        </div>
                    </article>
                ))}
            </div>
        );
    },
});
